// Create Scenario Page Entry Point
import '../../js/config.js';
import '../../js/initSideNav.js';
import '../../js/translations.js';
import '../../js/utils/TokenManager.js';
import '../../js/create/imageGeneration.js';
import { initializeScenarioForm } from '../../js/create/forms/scenarioForm.js';
import { initializeAIAssistant } from '../../js/create/aiAssistant.js';
import { initializePromptAutocomplete } from '../../js/create/promptAutocomplete.js';
import { initializeBackgroundDropdown } from '../../js/create/backgroundDropdown.js';

// Make available for dynamic textarea creation
window.initializePromptAutocomplete = initializePromptAutocomplete;

document.addEventListener('DOMContentLoaded', async () => {
  await initializeScenarioForm();
  await initializeAIAssistant();
  await initializePromptAutocomplete('custom-bg-textarea', 'backgroundPrompt');
  await initializeBackgroundDropdown();
});
